import { SpaceBetween, Container, FormField, Icon, Button } from '@amzn/awsui-components-react';
import { BulkUpsertAmbassadorsCommandOutput } from '@amzn/red-velvet-api';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function AmbassadorBulkUpdateDisplay({
  update,
}: {
  update: BulkUpsertAmbassadorsCommandOutput | null;
}) {
  const { t } = useTranslation(['ambassadors', 'translation']);
  const navigate = useNavigate();

  const totalEntries = update
    ? update.numberOfNewRecords + update?.numberOfUpdatedRecords + update?.numberOfSkippedRecords
    : 0;

  return (
    <SpaceBetween direction="vertical" size="m">
      <Container>
        <FormField label={`${t('bulkUpdate.ambassadors.entries', { count: totalEntries })}`}>
          <div style={{ color: '#656871' }}>
            <SpaceBetween direction="vertical" size="xs">
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="check"
                  variant="success"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsAdded', { count: update?.numberOfNewRecords ?? 0 })}`}
                </span>
              </div>
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="check"
                  variant="success"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsUpdated', { count: update?.numberOfUpdatedRecords ?? 0 })}`}
                </span>
              </div>
              <div>
                <Icon
                  size="inherit"
                  className="bulk-upload-result-icon"
                  name="close"
                  variant="normal"
                />
                <span style={{ verticalAlign: 'middle' }}>
                  {`${t('bulkUpdate.ambassadors.ambassadorsSkipped', { count: update?.numberOfSkippedRecords ?? 0 })}`}
                </span>
              </div>
            </SpaceBetween>
          </div>
        </FormField>
      </Container>
      <div style={{ float: 'right' }}>
        <SpaceBetween direction="horizontal" size="s">
          <Button
            variant="normal"
            disabled={false}
            loading={false}
            onClick={() => {
              navigate('/ambassadors/bulk-update');
            }}
          >
            {t('bulkUpdate.ambassadors.previous')}
          </Button>
          <Button
            variant="normal"
            disabled={false}
            loading={false}
            onClick={() => {
              navigate('/ambassadors');
            }}
          >
            {t('bulkUpdate.ambassadors.updateDirectory')}
          </Button>
        </SpaceBetween>
      </div>
    </SpaceBetween>
  );
}
